// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';
import { SetRateSchedule } from './set-rate-schedule';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SetRateCalcDate extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  adminId!: number;
  adminTypeId?: number;
  createdAt!: Date;
  createdBy?: string;
  rateCalcDate?: Date;
  rateScheduleId?: number;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  rateSchedule!: SetRateSchedule;
}

